import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect, useState } from "react";
import { API } from "../api";

const Testimonial = () => {
  const [playingVideoIndex, setPlayingVideoIndex] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [testimonialContent, setTestimonialContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const cardSpacing = 10;
  const visibleSlides = 3;

  // Fetch testimonial data from API
  const fetchTestimonialData = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API}/api/testimonial`, {
        method: "GET",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch testimonial data");
      }

      const data = await response.json();

      if (data.isSuccess && data.payload) {
        setTestimonialContent(data.payload);
      } else {
        throw new Error("Invalid data format");
      }
    } catch (error) {
      console.error("Error fetching testimonial data:", error);
      setError(error.message);
      // Fallback to empty structure
      setTestimonialContent({
        smallTitle: "Testimonial",
        mainTitle: "What Our",
        highlightTitle: "Happy Client Say About Us",
        testimonials: []
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    AOS.init({ duration: 1000 });
    fetchTestimonialData();

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Helper function to get media URL
  const getMediaUrl = (mediaObject) => {
    if (!mediaObject) return "";
    if (mediaObject.id) {
      return `${API}/api/media/${mediaObject.id}`;
    } else {
      return `${API}/api/media/${mediaObject}`;
    }
  };

  const scrollRight = () => {
    if (testimonialContent?.testimonials && currentSlide < testimonialContent.testimonials.length - 1) {
      setCurrentSlide(currentSlide + 1);
    }
  };

  const scrollLeft = () => {
    if (currentSlide > 0) {
      setCurrentSlide(currentSlide - 1);
    }
  };

  const getCardStyle = (index) => {
    if (!testimonialContent?.testimonials) return { display: "none" };

    if (isMobile) {
      return {
        display: index === currentSlide ? "inline-block" : "none",
        cursor: "pointer",
        width: "100%",
        marginRight: 0,
      };
    } else {
      const offset = index - currentSlide;
      if (Math.abs(offset) <= Math.floor(visibleSlides / 2)) {
        const cardWidth = offset === 0 ? 80 : 10;
        return {
          display: "inline-block",
          cursor: "pointer",
          width: `${cardWidth}%`,
          transition: "width 0.5s ease-in-out",
          marginRight: `${cardSpacing}px`,
        };
      } else {
        return { display: "none" };
      }
    }
  };

  if (loading) {
    return (
      <div className="col-11 m-auto mt-4">
        <div className="d-flex justify-content-center align-items-center" style={{ height: "200px" }}>
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="col-11 m-auto mt-4">
        <div className="alert alert-danger" role="alert">
          Error loading testimonials: {error}
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="col-11 m-auto mt-4">
        <p className="fs-5" data-aos="fade-up">
          {testimonialContent?.smallTitle || "Testimonial"}
        </p>
        <p className="fs-1 fw-semibold" data-aos="fade-up">
          {testimonialContent?.mainTitle || "What Our"}
        </p>
        <p className="fs-1 fw-bold org line-height-1" data-aos="fade-up">
          {testimonialContent?.highlightTitle || "Happy Client Say About Us"}
        </p>
      </div>

      <div className="d-flex align-items-center position-relative">
        <button
          className="buttonSlider position-absolute"
          style={{ top: "48%", left: "20px", zIndex: "1" }}
          onClick={scrollLeft}
          disabled={currentSlide === 0}
        >
          <i className="bi bi-chevron-left"></i>
        </button>

        <div
          className="testimonial mt-3 d-flex align-items-center"
          style={{ width: "100%", overflow: "hidden", whiteSpace: "nowrap" }}
        >
          {testimonialContent?.testimonials?.map((testimonial, i) => (
            <div
              className="video-card rounded-4"
              style={getCardStyle(i)}
              key={i}
              data-aos="zoom-in"
              onClick={() => setPlayingVideoIndex(i)}
            >
              <div
                className="m-auto testimonial-video-card-height"
                // style={{ height: "60vh", position: "relative" }}
              >
                <img
                  src={getMediaUrl(testimonial.thumbnail)}
                  alt={testimonial.thumbnail?.alt || "Video Thumbnail"}
                  style={{
                    width: "100%",
                    height: "100%",
                    borderRadius: "10px",
                    objectFit: "cover",
                  }}
                  crossOrigin="anonymous"
                // onError={(e) => {
                //   e.target.src = "https://via.placeholder.com/300x200?text=Thumbnail+Not+Found";
                // }}
                />
                {/* You can add ReactPlayer back when you want video playback */}
                {/* {playingVideoIndex === i && (
                  <ReactPlayer
                    style={{ borderRadius: "10px" }}
                    width="100%"
                    height="100%"
                    controls
                    url={testimonial.videoUrl}
                    playing
                  />
                )} */}
              </div>
            </div>
          ))}

          {(!testimonialContent?.testimonials || testimonialContent.testimonials.length === 0) && (
            <div className="text-center w-100 py-5">
              <p className="text-muted">No testimonials available</p>
            </div>
          )}
        </div>

        <button
          className="buttonSlider position-absolute"
          style={{ top: "48%", right: "20px", zIndex: "1" }}
          onClick={scrollRight}
          disabled={!testimonialContent?.testimonials || currentSlide === testimonialContent.testimonials.length - 1}
        >
          <i className="bi bi-chevron-right"></i>
        </button>
      </div>
    </div>
  );
};

export default Testimonial;